<div
  class="backdrop"
  (click)="closeHandler()"
  [ngClass]="{ active: dialog }"
></div>

<div
  class="dialog"
  *ngIf="dialog"
  [@enterAnimationDialog]
  (@enterAnimationDialog.done)="animDone($event)"
>
  <div class="dialog__popup">
    <div class="dialog__header">
      <div class="dialog__timer" *ngIf="timer">
        ({{ timer }}<span> сек</span>)
      </div>
      <span class="cross" (click)="closeHandler()">
        <svg
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22.5" cy="22.5" r="22.5" fill="#D6DBDE" />
          <path
            d="M17 17L28 28"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            d="M28 17L17 28"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </span>
    </div>
    <div class="dialog__message" *ngIf="dialog.message">
      <div [innerHtml]="dialog.message"></div>
    </div>
    <div class="dialog__message" *ngIf="dialog.template">
      <ng-container
        *ngTemplateOutlet="
          dialog.template.ref;
          context: dialog.template.context
        "
      ></ng-container>
    </div>
  </div>
</div>
